export default [
    {
        title: "01 - App Installation",
        url: "https://support.arenacommerce.com/support/solutions/folders/6000238957",
        items: [
            {
                title: "How to install Wishlist Compare by Arena",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243474-how-to-install-wishlist-compare-plus-by-arena",
            },
            {
                title: "General Interface",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243477-general-interface",
            },
            {
                title: "How to Fix Not Found Error",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243476-how-to-fix-not-found-error",
            },
            {
                title: `App code's position in your theme`,
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000246930-app-code-s-position-in-your-theme",
            },
        ],
    },
    {
        title: "02 - Modify the Wishlist & Compare features",
        url: "https://support.arenacommerce.com/support/solutions/folders/6000238958",
        items: [
            {
                title: "General Settings",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000245338-general-settings",
            },
            {
                title: `How to modify the Wishlist & Compare buttons`,
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243479-how-to-modify-the-wishlist-compare-buttons",
            },
            {
                title: `Alert emails.`,
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000245363-alert-emails",
            },
            {
                title: `Statistic on Wishlist App`,
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000246085-statistic-on-wishlist-app",
            },
        ],
    },
    {
        title: "03 - Show Wishlist - Compare on your storefront",
        url: "https://support.arenacommerce.com/support/solutions/folders/6000238959",
        items: [
            {
                title: "Adding Wishlist - Compare button on Collection pages",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243480-adding-wishlist-compare-button-on-collection-pages",
            },
            {
                title: `Adding Wishlist - Compare buttons on Product pages`,
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000246781-adding-wishlist-compare-buttons-on-product-pages",
            },
        ],
    },
    {
        title: "04 - Remove Wishlist - Compare App",
        url: "https://support.arenacommerce.com/support/solutions/folders/6000238960",
        items: [
            {
                title: "How to remove Wishlist Compare Plus App from your store",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243481-how-to-remove-wishlist-compare-plus-app-from-your-store",
            },
        ],
    },
    {
        title: "05 - Policy",
        url: "https://support.arenacommerce.com/support/solutions/folders/6000238961",
        items: [
            {
                title: "Wishlist - Compare Privacy Policy",
                url:
                    "https://support.arenacommerce.com/support/solutions/articles/6000243482-wishlist-compare-privacy-policy",
            },
        ],
    },
]
